import { useTranslation } from "react-i18next"

const SuspensionSuccessModal = ({ isOpen, onClose, onRedirect }) => {
  const { t, i18n } = useTranslation()

  if (!isOpen) return null

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#FFFFFF",
          borderRadius: "16px",
          padding: "32px 40px 40px 40px",
          maxWidth: "500px",
          width: "100%",
          boxShadow: "0 25px 50px rgba(0, 0, 0, 0.25)",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
        dir={i18n.dir()}
      >
        {/* Close X Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "8px",
            borderRadius: "8px",
            transition: "background 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#F9FAFB"
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "transparent"
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6B7280"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {/* Modal Content */}
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          {/* Success Icon */}
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: "#D1FAE5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px auto",
            }}
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#10B981"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 6L9 17l-5-5" />
            </svg>
          </div>

          <h2
            style={{
              fontFamily: '"Red Hat Display", sans-serif',
              fontSize: "24px",
              fontWeight: 600,
              color: "#303E4E",
              margin: "0 0 16px 0",
            }}
          >
            {t("accountManagement.modals.suspensionSuccess.title")}
          </h2>
          
          <p
            style={{
              fontFamily: '"Red Hat Display", sans-serif',
              fontSize: "16px",
              color: "#6B7280",
              lineHeight: "1.6",
              margin: "0 0 32px 0",
            }}
          >
            {t("accountManagement.modals.suspensionSuccess.description")}
          </p>

          {/* Action Button */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              onClick={() => {
                onClose()
                if (onRedirect) {
                  onRedirect()
                }
              }}
              style={{
                padding: "12px 32px",
                background: "#8548A8",
                color: "#FFFFFF",
                border: "none",
                borderRadius: "12px",
                fontFamily: '"Red Hat Display", sans-serif',
                fontSize: "16px",
                fontWeight: 600,
                cursor: "pointer",
                transition: "all 0.2s ease",
                minWidth: "140px",
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "#7A4397"
                e.target.style.transform = "translateY(-1px)"
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "#8548A8"
                e.target.style.transform = "translateY(0)"
              }}
            >
              {t("accountManagement.modals.suspensionSuccess.confirm")}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SuspensionSuccessModal
